import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterRegisteredDocuments from 'views/teacher/registered-documents/filterRegisteredDocuments'; // Importing filter component
import TableRegisteredDocuments from 'views/teacher/registered-documents/tableRegisteredDocuments'; // Importing table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the registered documents view.
 * @extends JetView
 */
export default class registeredDocumentsView extends JetView {
    /**
     * Configures the layout of the registered documents view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            type: 'wide',
            rows: [], // Placeholder for future rows
        };
        const toolbar = {
            view: 'toolbar', // Toolbar component
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetching
                },
            ],
        };
        const left = {
            Width: 250, // Width of the left column
            responsiveCell: false, // Disable responsive behavior for this cell
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left column
                    css: theme, // Apply current theme
                    elements: [
                        {
                            view: 'label', // Label component
                            label: _('Documentos Registrados'), // Translated label text
                            width: 150, // Width of the label
                        },
                    ],
                },
                FilterRegisteredDocuments, // Filter component for registered documents
                TableRegisteredDocuments, // Table component for displaying documents
                toolbar, // Toolbar for pagination
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            type: 'wide', // Type of layout
            responsive: true, // Enable responsive behavior
            cols: [left, { view: 'resizer' }], // Columns layout with a resizer
        };
    }
}

// FILE DOCUMENTED
